"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var empty_1 = require("rxjs/observable/empty");
var core_1 = require("@angular/core");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var material_1 = require("@angular/material");
var delete_confirm_dialog_1 = require("../delete-confirm-dialog");
var router_1 = require("@angular/router");
require("./header-three-dot-menu.component.scss");
var operators_1 = require("rxjs/operators");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var noop_1 = require("rxjs/util/noop");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var zip_1 = require("rxjs/observable/zip");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var from_1 = require("rxjs/observable/from");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
/**
 * @author tatevik.marikyan
 * @since 26/06/2018
 */
var HeaderThreeDotMenuComponent = /** @class */ (function (_super) {
    __extends(HeaderThreeDotMenuComponent, _super);
    function HeaderThreeDotMenuComponent(_deService, _dePermissionService, _authorizationService, _authenticationService, _currentLanguageProvider, _documentService, _applicationPropertiesService, _formDialog, _httpClient, _cookieService, _router) {
        var _this = _super.call(this) || this;
        _this._deService = _deService;
        _this._dePermissionService = _dePermissionService;
        _this._authorizationService = _authorizationService;
        _this._authenticationService = _authenticationService;
        _this._currentLanguageProvider = _currentLanguageProvider;
        _this._documentService = _documentService;
        _this._applicationPropertiesService = _applicationPropertiesService;
        _this._formDialog = _formDialog;
        _this._httpClient = _httpClient;
        _this._cookieService = _cookieService;
        _this._router = _router;
        _this.classes = '';
        _this.customActions = [];
        _this.withDeleteButton = true;
        _this.customActionEmitter = new core_1.EventEmitter();
        _this._canDelete = false;
        _this._isView = true;
        _this._hasChangeHistoryPermission = false;
        _this.GLOBAL_AUDIT_PERMISSION_KEY = '97f2eb0b-9c8e-4f76-8ce7-a725e31afd84';
        return _this;
    }
    Object.defineProperty(HeaderThreeDotMenuComponent.prototype, "userHelpItems", {
        get: function () {
            return this._userHelpItems;
        },
        set: function (value) {
            this._userHelpItems = value
                ? value.filter(function (userHelpItem) {
                    return !!userHelpItem.url ||
                        (userHelpItem.documentId &&
                            userHelpItem.documentId !== -1);
                })
                : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderThreeDotMenuComponent.prototype, "isView", {
        get: function () {
            return this._isView;
        },
        set: function (value) {
            this._isView = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderThreeDotMenuComponent.prototype, "canDelete", {
        get: function () {
            return this._canDelete;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderThreeDotMenuComponent.prototype, "hasChangeHistoryPermission", {
        get: function () {
            return this._hasChangeHistoryPermission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderThreeDotMenuComponent.prototype, "showMenu", {
        get: function () {
            return this.isView && (this.canDelete || this.hasChangeHistoryPermission)
                || (this.userHelpItems && this.userHelpItems.length > 0)
                || (this.customActions && this.customActions.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderThreeDotMenuComponent.prototype, "showDivider", {
        get: function () {
            var hasHelpItems = this.userHelpItems && this.userHelpItems.length > 0;
            var hasCustomActions = this.customActions && this.customActions.length > 0;
            var mustShowDeleteOrChangeHistoryButtons = this.isView && (this.canDelete || this.hasChangeHistoryPermission);
            return (hasHelpItems || hasCustomActions) && mustShowDeleteOrChangeHistoryButtons;
        },
        enumerable: true,
        configurable: true
    });
    HeaderThreeDotMenuComponent.prototype.ngOnInit = function () {
        this.deletePermissionInit();
        this.hasChangeHistoryPermissionInit();
        this.currentLanguage$ = this._currentLanguageProvider.getCurrentLanguage();
    };
    HeaderThreeDotMenuComponent.prototype.deleteAction = function () {
        var _this = this;
        this._formDialog
            .open(delete_confirm_dialog_1.DeleteConfirmDialogComponent, {
            disableClose: true,
            autoFocus: true,
            height: 'auto',
            width: '450px',
        })
            .afterClosed()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (result) {
            if (result) {
                _this.deleteEntity();
            }
        }, console.error);
    };
    HeaderThreeDotMenuComponent.prototype.onChangeHistoryClick = function () {
        this._router
            .navigateByUrl("audit/" + this.systemName + "/" + this.entityInstanceId)
            .then(noop_1.noop);
    };
    HeaderThreeDotMenuComponent.prototype.onCustomAction = function (functionId) {
        this.customActionEmitter.emit(functionId);
    };
    HeaderThreeDotMenuComponent.prototype.onUserHelpItemClick = function (userHelpItem) {
        var _this = this;
        if (userHelpItem.documentId && userHelpItem.documentId !== -1) {
            this._deService
                .getDocumentTokenByDocumentId(this.systemName, userHelpItem.documentId)
                .pipe(operators_1.first(), operators_1.switchMap(function (authInfo) {
                return zip_1.zip(_this._documentService.getDownloadUrl(userHelpItem.documentId, authInfo), _this._documentService.getDocumentInfo(userHelpItem.documentId));
            }), operators_1.tap(function (urlAndInfo) {
                if (urlAndInfo[1].name.toLowerCase().endsWith('pdf')) {
                    _this.openPdfInNewTab(urlAndInfo[0]);
                }
                else {
                    _this._documentService.downloadDocument(urlAndInfo[0], idm_document_service_client_js_1.FileType.ORIGINAL);
                }
            }))
                .subscribe(noop_1.noop, console.error);
        }
        else {
            window.open(userHelpItem.url);
        }
    };
    // TODO: Remove this function when a similar functionality is available in document service
    HeaderThreeDotMenuComponent.prototype.openPdfInNewTab = function (documentUrl) {
        var _this = this;
        zip_1.zip(from_1.from(this._applicationPropertiesService.getProperty('document-service-url')), this._authenticationService.getUserData())
            .pipe(operators_1.first(), operators_1.mergeMap(function (data) {
            return _this._httpClient.get(data[0] + "/document/" + documentUrl + "?fileType=" + idm_document_service_client_js_1.FileType.ORIGINAL + "&userID=" + data[1].userId, { responseType: 'arraybuffer' });
        }), operators_1.tap(function (response) {
            return window.open(URL.createObjectURL(new Blob([response], { type: 'application/pdf' })));
        }))
            .subscribe(noop_1.noop, console.error);
    };
    /**
     * Initializes Delete permission by checking Categories De Permissions for given entity
     */
    HeaderThreeDotMenuComponent.prototype.deletePermissionInit = function () {
        var _this = this;
        if (this.entityInstanceId && this.withDeleteButton) {
            this._dePermissionService
                .getCategoryDePermissionsByInstance(this.systemName, this.entityInstanceId)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (dePermission) {
                _this._canDelete = dePermission.canDelete;
            }, console.error);
        }
    };
    HeaderThreeDotMenuComponent.prototype.hasChangeHistoryPermissionInit = function () {
        var _this = this;
        this._authenticationService
            .getUserData()
            .pipe(operators_1.mergeMap(function (userData) {
            return _this._authorizationService.getPermissionAccessValue(userData.userId, _this.GLOBAL_AUDIT_PERMISSION_KEY);
        }), operators_1.tap(function (permissionValue) {
            _this._hasChangeHistoryPermission =
                permissionValue.access !== idm_authorization_client_js_1.Access.DENIED;
        }))
            .subscribe(noop_1.noop, console.log);
    };
    /**
     * Deletes Entity by double checking Delete Permission
     * Navigates to following pages if below result appears:
     * 1. no delete permission  - no-permission/delete
     * 2. delete                - successfully-deleted
     * 3. no item for delete    - deleted
     */
    HeaderThreeDotMenuComponent.prototype.deleteEntity = function () {
        var _this = this;
        this._dePermissionService
            .getCategoryDePermissionsByInstance(this.systemName, this.entityInstanceId)
            .pipe(operators_1.switchMap(function (dePermission) {
            if (dePermission.canDelete) {
                return _this._deService
                    .deleteById(_this.systemName, _this.entityId)
                    .pipe(operators_1.tap(function () {
                    return _this._router.navigateByUrl('dynamic-de/successfully-deleted');
                }), operators_1.catchError(function (err) {
                    if (err.status === 404) {
                        _this._router
                            .navigateByUrl('dynamic-de/deleted')
                            .then(noop_1.noop);
                    }
                    return empty_1.empty();
                }));
            }
            else {
                return _this._router.navigateByUrl('dynamic-de/no-permission/delete');
            }
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, console.error);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderThreeDotMenuComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderThreeDotMenuComponent.prototype, "classes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderThreeDotMenuComponent.prototype, "systemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderThreeDotMenuComponent.prototype, "entityId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderThreeDotMenuComponent.prototype, "entityInstanceId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderThreeDotMenuComponent.prototype, "customActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderThreeDotMenuComponent.prototype, "withDeleteButton", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], HeaderThreeDotMenuComponent.prototype, "customActionEmitter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderThreeDotMenuComponent.prototype, "userHelpItems", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], HeaderThreeDotMenuComponent.prototype, "isView", null);
    HeaderThreeDotMenuComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'header-three-dot-menu',
            template: require('./header-three-dot-menu.component.html'),
        }),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.DeService,
            idm_de_service_client_js_1.DePermissionService,
            idm_authorization_client_js_1.AuthorizationService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_document_service_client_js_1.DocumentService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            material_1.MatDialog,
            idm_authentication_client_js_1.HttpClientWrapper,
            idm_authentication_client_js_1.CookieService,
            router_1.Router])
    ], HeaderThreeDotMenuComponent);
    return HeaderThreeDotMenuComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HeaderThreeDotMenuComponent = HeaderThreeDotMenuComponent;
//# sourceMappingURL=header-three-dot-menu.component.js.map